import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

const getPackages = async (level = '') => {
  try {
    const response = await api.get(`${QUALITY_SERVICE_API_URL}/hub/test-history/packages?level=${level}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching packages:', error);
    throw error;
  }
};

const usePackages = (level = '') => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const result = await getPackages(level);
        // Add "All packages" as the first option
        const packagesWithAll = ["All packages", ...result];
        setData(packagesWithAll);
      } catch (err) {
        setError(err);
        // Fallback to hardcoded list if API fails
        setData([
          "All app packages"
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [level]);

  return { data, loading, error };
};

export default usePackages;
